import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import {
    Dialog,
    DialogContent,
    Button,
    MenuItem,
    Select,
    Grid,
    Typography,
    DialogTitle
} from '@material-ui/core';

import { editarEstadoExpediente, updateDestinoComprobante } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { DESTINOS_COMPROBANTE, MENU_MESA_ENTRADA } from '../../../utils/constants';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

const align = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    color: "#777"
}

const title = {
    textAlign:"center",
    fontWeight:"lighter",
    color: "#444",
    fontSize: "1.1em"
}

export const ModalComprobantes = ({open, setOpen, idExpedientes, idDestino, setIdDestino, setSelected, retorno}) => {
    const dispatch = useDispatch();

    const { destinos, activeBreadcrumb } = useSelector(state => state.mesaEntrada);

    const [observacion, setObservacion] = useState("");

    const handleClose = () => {
        setOpen(false);
        setObservacion("");
        setIdDestino(activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES ? DESTINOS_COMPROBANTE.LIQUIDACIONES : DESTINOS_COMPROBANTE.SECRETARIA_ADMINISTRATIVA);
        retorno.setExpedientesRetorno(null);
    };

    const handleSubmit = () => {
        if(retorno.expedientesRetorno !== null){
            dispatch(editarEstadoExpediente({expedientes: retorno.expedientesRetorno.expedientes, observacion}, retorno.expedientesRetorno.formValues, retorno.expedientesRetorno.setSelected, true));
        }else{
            dispatch(updateDestinoComprobante({idExpedientes, idDestino, observacion}));
        }
        setOpen(false);
        setIdDestino(activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES ? DESTINOS_COMPROBANTE.LIQUIDACIONES : DESTINOS_COMPROBANTE.SECRETARIA_ADMINISTRATIVA);
        setSelected([]);
        retorno.setExpedientesRetorno(null);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
        >
            <DialogTitle>
                <Typography style={title}>{retorno.expedientesRetorno === null ? "Desea modificar el destino del comprobante?" : "Desea retornar el comprobante?"}</Typography>
            </DialogTitle>
            <DialogContent>
                <ValidatorForm
                    onSubmit={handleSubmit}
                    style={{ flexGrow: "1"}}
                >
                    <Grid container justify='center' spacing={1}>
                        {retorno.expedientesRetorno === null &&
                            <Grid item xs={12} style={align}>
                                <Typography variant="button" align="center">Destino del comprobante</Typography>
                                <Select
                                    labelId="demo-customized-select-label"
                                    id="demo-customized-select"
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    value={idDestino}
                                    onChange={e => {
                                        setIdDestino(e.target.value);
                                        setObservacion("");
                                    }}
                                    style={{marginTop: ".5em"}}
                                >
                                    {destinos.filter(item => item.id !== DESTINOS_COMPROBANTE.MESA_ENTRADA).map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
                                </Select>
                            </Grid>
                        }
                        <Grid item xs={12} style={retorno.expedientesRetorno === null ? {...align, marginTop: "1.5em"}: align}>
                            <Typography variant="button" align='center'>Observación</Typography>
                            <TextValidator
                                multiline
                                rows={3}
                                fullWidth
                                variant="outlined"
                                label="Observacion"
                                name="observacion"
                                value={observacion}
                                onChange={e => setObservacion(e.target.value)}
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                validators={[
                                    "required",
                                    "minStringLength:10",
                                    "maxStringLength:100"
                                ]}
                                errorMessages={[
                                    "Debe ingresar un motivo de baja",
                                    "El motivo de baja debe tener al menos 10 caracteres",
                                    "El motivo de baja no debe tener más de 100 caracteres"
                                ]}
                                style={{marginTop: ".5em"}}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} align="right">
                        <Button onClick={handleClose} color="primary">
                            Cancelar
                        </Button>
                        <Button type='submit' color="primary">
                            Modificar
                        </Button>
                    </Grid>
                </ValidatorForm>
            </DialogContent>
        </Dialog>
    )
}
